if (!customElements.get('countdown-timer')) {
	class Countdown extends HTMLElement {
		constructor() {
			super()
			const isMockEnabled =
				this.getAttribute('data-enable-mock-timer') === 'true'

			if (isMockEnabled) {
				const mockPickerDay = Number(
					this.getAttribute('data-enable-mock-picker-day')
				)
				const mockPickerHour = Number(
					this.getAttribute('data-enable-mock-picker-hours')
				)

				const nowDate = new Date()
				const mockTargetDate = new Date(
					nowDate.getTime() +
						(mockPickerDay * 24 + mockPickerHour) * 60 * 60 * 1000
				)

				this.countdownDate = mockTargetDate
			} else {
				const time = this.getAttribute('data-time') || '00:00'
				const safeTime = time.length === 5 ? `${time}:00` : time
				const [tHour, tMin, tSec] = safeTime.split(':').map(Number)

				const now = new Date()
				let targetDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), tHour, tMin, tSec || 0)

				if (targetDate.getTime() <= now.getTime()) {
					targetDate = new Date(targetDate.getTime() + 24 * 60 * 60 * 1000)
				}

				this.countdownDate = targetDate
			}

			this.completedCountdown = this.getAttribute('data-completed')
			this.countdown = this.querySelector('.countdown__main')
			this.countdownHeading = this.querySelector('.countdown__end-info')
			this.daysEl = this.querySelector('.countdown_block_days')
			this.hoursEl = this.querySelector('.countdown_block_hours')
			this.minutesEl = this.querySelector('.countdown_block_minutes')
			this.secondsEl = this.querySelector('.countdown_block_seconds')
			this.section = this.closest('.countdown-section')

			if (this.daysEl) this.daysEl.textContent = ''
			if (this.hoursEl) this.hoursEl.textContent = ''
			if (this.minutesEl) this.minutesEl.textContent = ''
			if (this.secondsEl) this.secondsEl.textContent = ''

			this.setInterval()
		}

		onInit() {
			const now = new Date()
			let distance = this.countdownDate.getTime() - now.getTime()

			if (distance < 0) {
				// Time ran out! Restart and advance by another 24 hours
				this.countdownDate = new Date(this.countdownDate.getTime() + 24 * 60 * 60 * 1000)
				distance = this.countdownDate.getTime() - now.getTime()
			}

			const days = Math.floor(distance / (1000 * 60 * 60 * 24))
			const hours = this.daysEl
				? Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
				: Math.floor(distance / (1000 * 60 * 60))
			const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
			const seconds = Math.floor((distance % (1000 * 60)) / 1000)

			if (this.daysEl) this.daysEl.textContent = String(days).padStart(2, '0')
			if (this.hoursEl)
				this.hoursEl.textContent = String(hours).padStart(2, '0')
			if (this.minutesEl)
				this.minutesEl.textContent = String(minutes).padStart(2, '0')
			if (this.secondsEl)
				this.secondsEl.textContent = String(seconds).padStart(2, '0')
		}

		setInterval() {
			clearInterval(this.interval)
			this.onInit()
			this.interval = setInterval(this.onInit.bind(this), 1000)
		}

		disconnectedCallback() {
			clearInterval(this.interval)
		}
	}

	customElements.define('countdown-timer', Countdown)
}
